"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOMEMADE_MODAL = exports.HOMEMADE_EXTERNAL = exports.HOMEMADE_IFRAME = exports.STANDARD = void 0;
var STANDARD = 'STANDARD';
exports.STANDARD = STANDARD;
var HOMEMADE_IFRAME = 'HOMEMADE_IFRAME';
exports.HOMEMADE_IFRAME = HOMEMADE_IFRAME;
var HOMEMADE_EXTERNAL = 'HOMEMADE_EXTERNAL';
exports.HOMEMADE_EXTERNAL = HOMEMADE_EXTERNAL;
var HOMEMADE_MODAL = 'HOMEMADE_MODAL';
exports.HOMEMADE_MODAL = HOMEMADE_MODAL;


//////////////////
// WEBPACK FOOTER
// ./js/constants/ConnectionType.js
// module id = 245
// module chunks = 209 210 211 212